import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getFormattedGrowthPlanProgressData } from '../utils/growthPlanApis';
import { getFormattedOnboardingProgressData } from '../utils/onboardingProgressApis';
export const initialState = {
  isFetchingOnboardingProgress: false,
  hasError: false,
  progress: 0,
  selectedView: '',
  groupKey: undefined,
  coac0001VariantTreatment: undefined,
  coac0002VariantTreatment: undefined
};
export const fetchOnboardingProgress = createAsyncThunk('onboardingProgress/fetchOnboardingProgress', portalId => getFormattedOnboardingProgressData(portalId));
export const fetchGrowthPlanProgress = createAsyncThunk('onboardingProgress/fetchGrowthPlanProgress', portalId => getFormattedGrowthPlanProgressData(portalId));
export const onboardingProgressSlice = createSlice({
  name: 'onboardingProgress',
  initialState,
  reducers: {
    setOnboardingProgress: (state, action) => {
      state.progress = action.payload.progress;
      state.selectedView = action.payload.selectedView;
      state.groupKey = action.payload.groupKey;
    },
    setCoac0001Variant: (state, action) => {
      state.coac0001VariantTreatment = action.payload;
    },
    setCoac0002Variant: (state, action) => {
      state.coac0002VariantTreatment = action.payload;
    }
  },
  extraReducers(builder) {
    builder.addCase(fetchOnboardingProgress.pending, state => {
      state.isFetchingOnboardingProgress = true;
    }).addCase(fetchOnboardingProgress.fulfilled, (state, action) => {
      state.isFetchingOnboardingProgress = false;
      state.progress = action.payload.progress;
      state.selectedView = action.payload.selectedView;
      state.groupKey = action.payload.groupKey;
    }).addCase(fetchOnboardingProgress.rejected, state => {
      state.isFetchingOnboardingProgress = false;
      state.hasError = true;
    }).addCase(fetchGrowthPlanProgress.pending, state => {
      state.isFetchingOnboardingProgress = true;
    }).addCase(fetchGrowthPlanProgress.fulfilled, (state, action) => {
      state.isFetchingOnboardingProgress = false;
      state.progress = action.payload.progress;
      state.selectedView = action.payload.selectedView;
      state.groupKey = action.payload.groupKey;
    }).addCase(fetchGrowthPlanProgress.rejected, state => {
      state.isFetchingOnboardingProgress = false;
      state.hasError = true;
    });
  }
});
export const {
  setOnboardingProgress,
  setCoac0001Variant,
  setCoac0002Variant
} = onboardingProgressSlice.actions;
export const getCoac0001Treatment = state => state.onboardingProgress.coac0001VariantTreatment;
export const getCoac0002Treatment = state => state.onboardingProgress.coac0002VariantTreatment;
export default onboardingProgressSlice.reducer;